/**
 * Utility functions for authentication and token management
 */

/**
 * Lấy token từ localStorage với fallback strategy
 * @returns JWT token string hoặc null
 */
export const getAuthToken = (): string | null => {
  // Ưu tiên key chính 'quanly_truonghoc_token', fallback về 'token'
  const token = localStorage.getItem('quanly_truonghoc_token') || localStorage.getItem('token');
  
  if (token) {
    // Kiểm tra định dạng JWT cơ bản (header.payload.signature)
    const tokenParts = token.split('.');
    if (tokenParts.length === 3) {
      return token;
    }
  }
  
  return null;
};

/**
 * Tạo headers cho API calls có authentication
 * @returns Headers object with Authorization header if token exists
 */
export const getAuthHeaders = (): HeadersInit => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
};

/**
 * Kiểm tra xem user đã đăng nhập hay chưa
 * @returns true if user is authenticated
 */
export const isAuthenticated = (): boolean => {
  return getAuthToken() !== null;
};

/**
 * Xóa token và user data khỏi localStorage
 */
export const clearAuthData = (): void => {
  localStorage.removeItem('quanly_truonghoc_token');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  sessionStorage.clear();
};

/**
 * Redirect về trang login nếu không có token
 */
export const requireAuth = (): void => {
  if (!isAuthenticated()) {
    window.location.href = '/auth/login';
  }
};
